import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as proyectAction from '../store/actions/proyectAction';

class NoConexion extends Component {
  componentDidMount() {
    this.props.setBreadCrumb({
      label: this.props.breadCrumbLabel,
      url: this.props.breadCrumbUrl,
    });
  }
  render() {
    const { t } = this.props;
    return (
      <div>
        <div className="p-col-12">
          <div className="card center">
            <h1>{t('No Conexion')}</h1>
          </div>
          <div className="center">
            <h1>{t('Algo salió mal.')}</h1>
            <h3>{t('api no disponible, intentelo mas tarde.')}</h3>
            <img
              alt="Logo"
              style={{ width: '20%', cursor: 'pointer' }}
              src="assets/layout/images/error.png"
            />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = rootReducer => {
  return rootReducer.proyect;
};
export default connect(
  mapStateToProps,
  proyectAction,
)(withTranslation('translations')(NoConexion));
